import Link, { propTypes, defaultProps } from './Link'

export { propTypes, defaultProps }
export default Link
